// extracted by mini-css-extract-plugin
module.exports = {"drop-zone":"styles_drop-zone__GMPxh","drop-zone__text":"styles_drop-zone__text__2QZZj","drop-zone__container":"styles_drop-zone__container__2K3zv"};